import { Body, Box, Center, Divider, Icon, VStack } from '@hover/blueprint';
import { iChevronRight } from '@hover/icons';
import { useCompositorControls } from '@hoverinc/rendering-compositor-react';
import React, { useEffect } from 'react';

import { TranslationNamespace, useTranslate } from 'src/shared/hooks';

const markColors = ['#2277D1', '#791E94', '#66D7D1', '#EE7674', '#150578'];

const assignedMarkColor = (index: number) =>
  markColors[index % markColors.length];
export const RegionFilter = ({
  regionIds,
  onClick,
}: {
  regionIds: string[];
  onClick: (regionId: string) => void;
}) => {
  const { setMarkedRegions } = useCompositorControls();
  const t = useTranslate(TranslationNamespace.DESIGN_STUDIO);
  useEffect(() => {
    setMarkedRegions(
      regionIds.map((regionId, idx) => ({
        regionId,
        color: markColors[idx % markColors.length],
      })),
    );

    // On component dismount, remove marked regions
    return () => {
      setMarkedRegions([]);
    };

    // Intentionally blank deps as this effect should only run a single time
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <VStack>
      {regionIds.map((regionId, idx) => (
        <Box
          backgroundColor="neutral.100"
          borderRadius={300}
          cursor="pointer"
          key={regionId}
          onClick={() => onClick(regionId)}
          paddingX="17px"
          paddingY="18px"
          width="100%"
        >
          <Center
            borderColor="neutral.300"
            borderRadius="50%"
            borderStyle="solid"
            borderWidth="2px"
            height="29px"
            margin={0}
            width="29px"
          >
            <Box
              backgroundColor={assignedMarkColor(idx)}
              borderRadius="50%"
              height="25px"
              width="25px"
            />
          </Center>
          <Body flexGrow={1} marginX={200} marginY={100}>
            {t('menu.filters.region.area')} {idx + 1}
          </Body>
          <Icon icon={iChevronRight} size="medium" />
        </Box>
      ))}
      <Divider orientation="horizontal" />
    </VStack>
  );
};
